import { useState } from 'react';

/**
 * Tracks a `Set<number>` of selected/toggled ids, e.g. pending row exclusions in a table
 * before they're applied.
 *
 * @example
 * const { selected, toggle, replace } = useToggleSet(excludedIds);
 * <input checked={!selected.has(row.id)} onChange={() => toggle(row.id)} />
 * // to discard pending edits and resync with the applied set:
 * replace(excludedIds);
 */
export function useToggleSet(initial?: Iterable<number>) {
    const [selected, setSelected] = useState<Set<number>>(new Set(initial));

    const toggle = (id: number) => {
        setSelected(prev => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    };

    const replace = (ids: Iterable<number>) => {
        setSelected(new Set(ids));
    };

    return { selected, toggle, replace };
}
